if (typeof ScrollingText !== "function") {
	class ScrollingText extends HTMLElement {
		constructor() {
			super();

			var ScrollingText = (function () {
				function getWidth(element) {
					var rect = element.getBoundingClientRect();
					return rect.right - rect.left;
				}

				function ScrollingText(box, speed, pauseOnHover) {
					var inner_element = (box.children && box.children[0]) || null;
					if (!inner_element) throw "No child node found";

					inner_element.style.position = "relative";

					this.position = 0;
					this.speed = speed;
					this.pauseOnHover = pauseOnHover;
					this.box_width = getWidth(box);
					this.inner_element_width = getWidth(inner_element);
					this.box = box;
					this.inner_element = inner_element.cloneNode(true);
					setUpChildrens.call(this);
				}

				function refreshWidths() {
					this.box_width = getWidth(this.box);
					this.inner_element_width = getWidth(this.box.children[0]);
				}

				function calculateNumElements() {
					return Math.ceil(this.box_width / this.inner_element_width) + 1;
				}

				function setUpChildrens() {
					var qty = calculateNumElements.call(this);
					if (qty > this.box.children.length) {
						for (var i = this.box.children.length; i < qty; i++)
							this.box.appendChild(this.inner_element.cloneNode(true));
					} else if (qty < this.box.children.length) {
						for (var i = qty; i < this.box.children.length; i++)
							this.box.removeChild(this.box.lastChild);
					}
				}

				function nextFrame(delta, direction) {
					if (this.pauseOnHover) {
						var hovered = false;
						var box = this.box;

						if (box && box.matches && box.matches(":hover")) {
							hovered = true;
						} else if (box && box.msMatchesSelector && box.msMatchesSelector(":hover")) {
							hovered = true;
						}

						var wrapper = box && box.parentElement;
						if (!hovered && wrapper) {
							if (wrapper.matches && wrapper.matches(":hover")) {
								hovered = true;
							} else if (wrapper.msMatchesSelector && wrapper.msMatchesSelector(":hover")) {
								hovered = true;
							}
						}

						if (hovered) {
							return;
						}
					}

					var self = this;
					refreshWidths.call(this);
					setUpChildrens.call(this);
					Array.prototype.forEach.call(this.box.children, function (el) {
						if (direction == "rtl") {
							el.style.transform = `translateX(${self.position}px)`;
						} else {
							el.style.transform = `translateX(${-self.position}px)`;
						}
					});
					this.position += (this.speed * delta) / 1000;
					if (this.position >= this.inner_element_width)
						this.position = this.position % this.inner_element_width;
				}

				ScrollingText.prototype = {
					start: function (direction) {
						if (this._running) return;
						this._running = true;
						var self = this;
						var last_time = null;
						var loop_func = function () {
							if (!self._running) return;
							var now = Date.now();
							var delta = last_time === null ? 0 : now - last_time;
							nextFrame.call(self, delta, direction);
							last_time = now;
							window.requestAnimationFrame(loop_func);
						};
						window.requestAnimationFrame(loop_func);
					},

					stop: function () {
						this._running = false;
					},
				};

				return ScrollingText;
			})();

			const speed =
				window.innerWidth > 768
					? parseInt(this.dataset.scrollingSpeed)
					: parseInt(this.dataset.scrollingSpeed) / 1.5;
			const direction = this.dataset.scrollingDirection;
			const pauseAttr = this.getAttribute("data-pause-on-hover");
			const shouldPauseOnHover =
				pauseAttr === null ? false : !(pauseAttr === "false" || pauseAttr === "0");
			const scrolling_text = new ScrollingText(this, speed, shouldPauseOnHover);

			const intersectionObserver = new IntersectionObserver((entries) => {
				const entry = entries[0];
				if (!entry) return;

				if (!entry.isIntersecting) {
					scrolling_text.stop();
					return;
				}

				scrolling_text.start(direction);
			});
			intersectionObserver.observe(this);
		}
	}

	if (typeof customElements.get("scrolling-text") == "undefined") {
		customElements.define("scrolling-text", ScrollingText);
	}
}
